import { render, staticRenderFns } from "./SidebarSearchByVideo.vue?vue&type=template&id=dc50de74"
import script from "./SidebarSearchByVideo.vue?vue&type=script&lang=js"
export * from "./SidebarSearchByVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports